/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorIndividualDeliveryTypename = "PharmacyCounselorIndividualDelivery" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorIndividualDelivery
 */
export interface PharmacyCounselorIndividualDelivery {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorIndividualDelivery
   */
  inquiryUrl?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorIndividualDelivery
   */
  providerType: PharmacyCounselorIndividualDeliveryProviderTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorIndividualDelivery
   */
  trackingNumber: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorIndividualDelivery
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorIndividualDeliveryProviderTypeEnum {
  Yamato = "yamato",
  Sagawa = "sagawa",
  YuPack = "yu-pack",
}

export function PharmacyCounselorIndividualDeliveryFromJSON(json: any): PharmacyCounselorIndividualDelivery {
  return PharmacyCounselorIndividualDeliveryFromJSONTyped(json, false);
}

export function PharmacyCounselorIndividualDeliveryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorIndividualDelivery {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorIndividualDeliveryTypename,

    inquiryUrl: !exists(json, "inquiry_url") ? undefined : json["inquiry_url"],
    providerType: json["provider_type"],
    trackingNumber: json["tracking_number"],
  };
}

export function PharmacyCounselorIndividualDeliveryToJSON(object?: PharmacyCounselorIndividualDelivery | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    inquiry_url: value.inquiryUrl,
    provider_type: value.providerType,
    tracking_number: value.trackingNumber,
  };
}
